export default __webpack_public_path__ + "static/SofiaProRegular-ce11f571c783b917004b088008f0e6ec.woff2";